import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";
/* This is the custom StimulusReflex controller for the ContactRecrutement Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
  /*
   * Regular Stimulus lifecycle methods
   * Learn more at: https://stimulusjs.org/reference/lifecycle-callbacks
   *
   * If you intend to use this controller as a regular stimulus controller as well,
   * make sure any Stimulus lifecycle methods overridden in ApplicationController call super.
   *
   * Important:
   * By default, StimulusReflex overrides the -connect- method so make sure you
   * call super if you intend to do anything else when this controller connects.
   */
  static targets = ["hm0_output"];
  connect() {
    //console.log("ContactRecrutement JS en cours ...");
    super.connect();
    // add your code here, if applicable

    if(
      $("#partial-opportunite-content").length &&
      $("#partial-opportunite-content").text().trim() == "Chargement en cours ..."
      ) {
        setTimeout(() => this.contacts_recrutement_hm_ajax_opportunite(), 300);
      }
      
    if(
      $("#partial-emaling-content").length &&
      $("#partial-emaling-content").text().trim() == "Chargement en cours ..."
      ) {
        setTimeout(() => this.contacts_recrutement_hm_ajax_emaling(), 300);
      }


    if(
    $("#partial-interlocuteur-content").length &&
    $("#partial-interlocuteur-content").text().trim() == "Chargement en cours ..."
    ) {
      setTimeout(() => this.contacts_recrutement_hm_ajax_interlocuteur(), 300);
    }

    
    if(
    $("#partial-participation-intervention").length &&
    $("#partial-participation-intervention").text().trim() == "Chargement en cours ..."
    ) {
      setTimeout(() => this.contacts_recrutement_hm_ajax_participation_intervention(), 300);
    }
    
    if(
    $("#partial-paie-content").length &&
    $("#partial-paie-content").text().trim() == "Chargement en cours ..."
    ) {
      setTimeout(() => this.contacts_recrutement_hm_ajax_paie(), 300);
    }


    if(
    $("#partial-prime-content").length &&
    $("#partial-prime-content").text().trim() == "Chargement en cours ..."
    ) {
      setTimeout(() => this.contacts_recrutement_hm_ajax_prime(), 300);
    }


    if(
    $("#partial-acompte-content").length &&
    $("#partial-acompte-content").text().trim() == "Chargement en cours ..."
    ) {
      setTimeout(() => this.contacts_recrutement_hm_ajax_acompte(), 300);
    }


    if(
    $("#partial-entretien-rh").length &&
    $("#partial-entretien-rh").text().trim() == "Chargement en cours ..."
    ) {
      setTimeout(() => this.contacts_recrutement_hm_ajax_entretien_rh(), 300);
    }


    if(
    $("#partial-arret-maladie").length &&
    $("#partial-arret-maladie").text().trim() == "Chargement en cours ..."
    ) {
      setTimeout(() => this.contacts_recrutement_hm_ajax_arret_maladie(), 300);
    }


    if(
    $("#partial-visite-medicale").length &&
    $("#partial-visite-medicale").text().trim() == "Chargement en cours ..."
    ) {
      setTimeout(() => this.contacts_recrutement_hm_ajax_visite_medicale(), 300);
    }


    if(
    $("#partial-justificatif-content").length &&
    $("#partial-justificatif-content").text().trim() == "Chargement en cours ..."
    ) {
      setTimeout(() => this.contacts_recrutement_hm_ajax_justificatif(), 300);

    }


    if(
    $("#partial-st-commande").length &&
    $("#partial-st-commande").text().trim() == "Chargement en cours ..."
    ) {
      setTimeout(() => this.contacts_recrutement_hm_ajax_st_commande(), 300);
    }


    if(
    $("#partial-diplome-content").length &&
    $("#partial-diplome-content").text().trim() == "Chargement en cours ..."
    ) {
      setTimeout(() => this.contacts_recrutement_hm_ajax_diplome(), 300);
    }


    if(
    $("#partial-formation-content").length &&
    $("#partial-formation-content").text().trim() == "Chargement en cours ..."
    ) {
      setTimeout(() => this.contacts_recrutement_hm_ajax_formation(), 300);
    }


    if(
    $("#partial-certification-content").length &&
    $("#partial-certification-content").text().trim() == "Chargement en cours ..."
    ) {
      setTimeout(() => this.contacts_recrutement_hm_ajax_certification(), 300);
    }


    if(
    $("#partial-competence-content").length &&
    $("#partial-competence-content").text().trim() == "Chargement en cours ..."
    ) {
      setTimeout(() => this.contacts_recrutement_hm_ajax_competence(), 300);
    }


    if(
    $("#partial-materiel-content").length &&
    $("#partial-materiel-content").text().trim() == "Chargement en cours ..."
    ) {
      setTimeout(() => this.contacts_recrutement_hm_ajax_materiel(), 300);
    }


    if(
    $("#partial-document-content").length &&
    $("#partial-document-content").text().trim() == "Chargement en cours ..."
    ) {
      setTimeout(() => this.contacts_recrutement_hm_ajax_document(), 300);
    }


    if(
    $("#partial-contact-content").length &&
    $("#partial-contact-content").text().trim() == "Chargement en cours ..."
    ) {
      setTimeout(() => this.contacts_recrutement_hm_ajax_contact(), 300);
    }


    if(
    $("#partial-collab-cv-content").length &&
    $("#partial-collab-cv-content").text().trim() == "Chargement en cours ..."
    ) {
      setTimeout(() => this.contacts_recrutement_hm_ajax_collab_cv(), 300);

    }


    if(
    $("#partial-reference-content").length &&
    $("#partial-reference-content").text().trim() == "Chargement en cours ..."
    ) {
      setTimeout(() => this.contacts_recrutement_hm_ajax_reference(), 300);

    }


    if(
    $("#partial-historique_employe-content").length &&
    $("#partial-historique_employe-content").text().trim() == "Chargement en cours ..."
    ) {
      setTimeout(() => this.contacts_recrutement_hm_ajax_historique_employe(), 300);
    }


    if(
    $("#partial-proposition-content").length &&
    $("#partial-proposition-content").text().trim() == "Chargement en cours ..."
    ) {
      setTimeout(() => this.contacts_recrutement_hm_ajax_proposition(), 300);
    }

  }

  
  get current_app() {
    return this.data.get("app");
  }
  get contacts_recrutement_id() {
    return this.data.get("contacts_recrutementid");
  }
  get url_solution() {
    return this.data.get("urlsolution");
  }
}
